import { createContext } from 'react';
import { ChatMessageContainerEnum } from './Chat.enum.ts';
import { tChatContext } from './Chat.types.ts';
import { ChatInfoEnum } from './components/ChatInfo/ChatInfo.enum.ts';

const initialState: tChatContext = {
  selectedTab: ChatInfoEnum.ATTRIBUTES,
  setSelectedTab: () => {},
  selectedMessageContainer: ChatMessageContainerEnum.CHAT,
  setSelectedMessageContainer: () => {},
  selectedTextAreaContainer: undefined,
  setSelectedTextAreaContainer: () => {},
  selectedChat: null,
  setSelectedChat: () => {},
  selectedChatLeadId: '',
  loading: false,
  setLoading: () => {},
  blockTextArea: false,
  setBlockTextArea: () => {},
  isComposerWalletBlocked: false,
  setComposerWalletBlocked: () => {},
  cursor: '',
  setCursor: () => {},
  rows: 0,
  setRows: () => {},
  messages: {
    cursor: '',
    events: [],
  },
  setMessages: () => {},
  replyMessage: null,
  setReplyMessage: () => {},
  resendIds: [],
  setResendIds: () => {},
  selectedChatsIds: [],
  setSelectedChatsIds: () => {},
  selectMessageToReply: () => {},
  funnelsWithStages: null,
  getFunnelsWithStages: () => {},
  updateChatEventsData: 0,
  setUpdateChatEventsData: () => {},
  chatInputContainerRef: { current: null },
  textAreaContainerRef: { current: null },
  showAllowTypesBanner: false,
  setShowAllowTypesBanner: () => {},
  followUps: [],
  setFollowUps: () => {},
  notes: [],
  setNotes: () => {},
  leadsalesAI: [],
  setLeadsalesAI: () => {},
  favoriteMessages: [],
  setFavoriteMessages: () => {},
  quickReplies: [],
  setQuickReplies: () => {},
  fetchQuickReplies: () => {},
  selectedNote: null,
  setSelectedNote: () => {},
  selectedFollowUp: null,
  setSelectedFollowUp: () => {},
  quickActionState: {
    id: '',
    isPublic: false,
    title: '',
    text: '',
    attachments: [],
  },
  setQuickActionState: () => {},
  isResending: false,
  setIsResending: () => {},
  droppedAttachments: [],
  setDroppedAttachments: () => {},
  chatEvents: [],
  setChatEvents: () => {},
  latestPage: null,
  returnToLatest: () => Promise.resolve(),
  templatePickerRequest: null,
  setTemplatePickerRequest: () => {},
  takeConversationRequest: null,
  setTakeConversationRequest: () => {},
  setNewFunnelID: () => {},
  textAreaRef: { current: null },
  // Summary functionality
  conversationSummary: null,
  isSummaryLoading: false,
  summaryError: null,
  summaryEligibility: null,
  generateSummary: async () => {},
  checkSummaryEligibility: async () => {},
  clearSummary: () => {},
  clearSummaryError: () => {},
  tagInputRef: { current: null },
  groupParticipants: [],
  setGroupParticipants: () => {},
  autoRespondEnabled: false,
  setAutoRespondEnabled: () => {},
  whatsAppWebConnection: {
    phase: 'idle',
    refetch: () => {},
  },
  leadAgentPaused: { paused: false, reason: null },
  refetchLeadAgentPaused: () => {},
};

export const ChatContext = createContext<tChatContext>(initialState);
